/**
 * @fileoverview
 * Space System for game logic
 */
'use strict';

goog.provide("Ntry.SpaceSystem");

goog.require("Ntry.STATIC");

Ntry.SpaceSystem = function() {
    this.scroll = null;

    this._scrollSpeed = 0;

    this._spaceWidth = 300;

    this._gridCallBack = null;

    this._isSafe = true;

    this._tileSize;

    this._isSlideAvailable = true;

    this._itemCount = 0;

    this._maxItem = 0;

    this._itemEntities = [];

    Ntry.addEventListener("run", this, this.toggleRun);
    Ntry.addEventListener("stop", this, this.toggleStop);
    Ntry.addEventListener("gridChange", this, this.getGridChangeEvent);
    Ntry.addEventListener("itemFire", this, this.getItemEvent);
    Ntry.addEventListener("executeEnd", this, this.getScriptEvent);
    Ntry.addEventListener("engineSliderMove", this, this.slide);
    Ntry.addEventListener("triggerWeapon", this, this.useItem);
};

(function(p){
    p.loadConfig = function() {
        this._maxItem = Ntry.configManager.getConfig("maxItem");
        this._maxItem = this._maxItem ? this._maxItem : 0;
        this._tileSize = Ntry.configManager.getConfig("tileSize");

        var isMapper = Ntry.configManager.getConfig("mapper");
        if (isMapper)
            this._spaceWidth = Number.MAX_VALUE;
        else {
            var spaceWidth = Ntry.configManager.getConfig("spaceWidth");
            this._spaceWidth = (spaceWidth - 4) * this._tileSize;
        }
    };

    p.update = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.GRID);

        if (!this.scroll)
            this.scroll = this.makeScrollComponent();

        // 1px move
        //

        var fieldForce = this.scroll.scrollX <= this._spaceWidth ? this._scrollSpeed : 0;

        for (var id in entities) {
            var entity = entities[id];
            var position = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.POSITION
            );
            var spaceShip = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.SPACE_SHIP
            );
            if (spaceShip) {
                Ntry.addVectorByDirection(
                    position,
                    spaceShip.direction,
                    spaceShip.direction != Ntry.STATIC.EAST ? this._scrollSpeed : 0
                );
                Ntry.addVectorByDirection(
                    position,
                    Ntry.STATIC.EAST,
                    fieldForce ? 0 : this._scrollSpeed
                );

                // exit map
                if ((position.y < 30 || position.y > 270) && this._isSafe) {
                    Ntry.dispatchEvent("complete", false, Ntry.STATIC.LOST);
                    Ntry.dispatchEvent("playSound", Ntry.STATIC.LOST);
                    this._isSafe = false;
                    this._scrollSpeed = 0;
                    Ntry.entityManager.addComponent(
                        id, {
                            type: Ntry.STATIC.ANIMATE,
                            animateType: Ntry.STATIC.VIBRATE,
                            animateValue: position.x
                        }
                    );
                }
            } else {
                position.x -= fieldForce;
            }
        }


        if (this._gridCallBack && this.scroll.scrollX % this._tileSize == 0) {
            this._gridCallBack.call();
            this._gridCallBack = null;
        }

        this.scroll.scrollX += this._scrollSpeed;
    };

    p.getScriptEvent = function() {
        this._scrollSpeed = 0;
        Ntry.dispatchEvent("complete", false, Ntry.STATIC.SIMOOROOK);
        Ntry.dispatchEvent("playSound", "ai_simoorook");
    }

    p.getItemEvent = function(itemType) {
        switch(itemType) {
            case Ntry.STATIC.AI_GOAL:
                this._scrollSpeed = 0;
                Ntry.dispatchEvent("complete", true);
                break;
            case Ntry.STATIC.AI_METEO:

                this._scrollSpeed = 0;
                Ntry.dispatchEvent("complete", false, Ntry.STATIC.COLLISION);
                break;
            case Ntry.STATIC.AI_ITEM:
                if (this._itemCount < this._maxItem)
                    this.addItemEntity(this._itemCount);
                this._itemCount++;
                this._itemCount = Math.min(this._itemCount, this._maxItem);
                break;
        }
    };

    p.getGridChangeEvent = function(cb) {
        this._gridCallBack = cb;
    };

    p.addItemEntity = function(cnt) {
        var em = Ntry.entityManager;
        var entity = em.addEntity();

        em.addComponent(entity.id, {
            type: Ntry.STATIC.BITMAP,
            image: 'item',
            regX: 10, regY: 10
        });

        var x = cnt * 30 + 20;
        em.addComponent(entity.id, {
            type: Ntry.STATIC.POSITION,
            x: x, y:280
        });

        this._itemEntities.push(entity.id);
    };

    p.removeItemEntity = function() {
        var em = Ntry.entityManager;
        var entityId = this._itemEntities.pop();
        em.removeEntity(entityId);
    };

    p.toggleRun = function() {
        this._scrollSpeed = 4;
        this._isSafe = true;
        this._isSlideAvailable = false;
        this.recoverSlide();
    };

    p.toggleStop = function() {
        this._itemCount = 0;
        this._scrollSpeed = 0;
        this.scroll.scrollX = 0;
        this._isSlideAvailable = true;
        this._gridCallBack = null;
        this._itemEntities = [];
    };

    p.useItem = function() {
        if (this._itemCount <= 0)
            return;
        Ntry.dispatchEvent("playSound", "ai_use_item");

        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);

        for (var id in entities) {
            var entity = entities[key];
            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM
            );
            if (itemComp.itemType != Ntry.STATIC.AI_METEO)
                continue;

            var position = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.POSITION
            );
            if (position.x > 0 && position.x <  100 * 4) {
                Ntry.entityManager.removeComponent(
                    id, Ntry.STATIC.ITEM
                );
                Ntry.entityManager.addComponent(
                    id, {
                        type: Ntry.STATIC.ANIMATE,
                        animateType: Ntry.STATIC.POP_OUT
                    }
                );
            }
        }
        this._itemCount--;
        this.removeItemEntity();
    };

    p.slide = function(ratio) {
        if (!this._isSlideAvailable)
            return;
        var newScrollX = this._spaceWidth * ratio;
        var delta = this.scroll.scrollX - newScrollX;

        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.POSITION);
        for (var id in entities) {
             var entity = entities[id];
            var position = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.POSITION
            );
            position.x += delta;
        }
        this.scroll.scrollX = newScrollX;
    };

    p.recoverSlide = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.POSITION);
        for (var id in entities) {
             var entity = entities[id];
            var position = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.POSITION
            );
            position.x += this.scroll.scrollX;
        }
        this.scroll.scrollX = 0;
    }

    p.makeScrollComponent = function() {
        var entity = Ntry.entityManager.addEntity();

        var component = Ntry.entityManager.addComponent(
            entity.id, {
                type: Ntry.STATIC.SCROLL
            }
        );
        return component;
    };

})(Ntry.SpaceSystem.prototype);
